module.exports = __webpack_public_path__ + "static/media/logo_tcyl.9a1730f2.png";